/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './Branding.style';

import EventBranding, { large } from './event/EventBranding';
import NavSponsorBranding from './sponsor/NavSponsorBranding';

type Props = {
  isSponsorShown: boolean,
};

const useStyles = createUseStyles(styles);

const BrandingDumb = ({ isSponsorShown }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes: Object = useStyles();

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const sponsortElt = isSponsorShown && <NavSponsorBranding />;

  return (
    <div className={classes.root}>
      <EventBranding variant={large} />
      {sponsortElt}
    </div>
  );
};

export default compose(React.memo)(BrandingDumb);
